// Pure, tax-data-independent utilities used across the employee-facing UI.
// The Section 125 optimizer that used to live here (calculateOptimalFlex, a
// hardcoded-2019-tax-bracket implementation) has been removed — it silently
// auto-saved stale numbers to real Employee records. Section 125/flex
// calculations now always go through the backend engine
// (server/src/services/proposalCalculationService.ts), see
// FlexCalculator.jsx and dynamicTaxCalculations.jsx.

/**
 * Calculate flex balance and max claimable amount (86% rule)
 */
export function calculateFlexBalance(flexAllocation, totalMonthlyPremiums) {
  const flexBalance = flexAllocation - totalMonthlyPremiums;
  const maxClaimable = flexBalance * 0.86; // 86% rule

  return {
    flexBalance,
    maxClaimable,
    utilizationRate: (totalMonthlyPremiums / flexAllocation) * 100
  };
}

/**
 * Calculate payroll deduction based on pay frequency
 */
export function calculatePayrollDeduction(annualAmount, payFrequency) {
  const payPeriodsPerYear = {
    weekly: 52,
    bi_weekly: 26,
    semi_monthly: 24,
    monthly: 12
  };

  const periods = payPeriodsPerYear[payFrequency] || 26;
  return annualAmount / periods;
}

/**
 * Calculate age from date of birth
 */
export function calculateAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}
